import {React,useState, useEffect} from 'react'
import { Link, useHistory } from "react-router-dom";
import { Button, Container, Paper, Typography, Grid, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import axios from 'axios';

const API_PATH = process.env.REACT_APP_API_PATH
const leader_id = 1;
const useStyles = makeStyles((theme) => ({
  root: {
    margin:0
  },
  subTitle:{
      fontSize:16,
      margin:10,
      color:"#669999"
  },
  menuContainer:{
      width:"100%"
  },
  paperContainer:{
      height:"60px",
      margin:"20px 0",
      backgroundColor:"#eceff1",
      borderRadius:20,
      justifyContent: "center",

  },
  paperText:{
      marginTop:"5px",
      fontSize:"18px",
      color: "#222222"
  }
}));

export default function Mygroup() {
    const classes = useStyles();
    const history = useHistory();
    const [member, setMember] = useState([])

    useEffect(() => {
        // history.push('/newmember')
        axios.get(API_PATH + `/mygroup?leader=${leader_id}`)
        .then(res=>{
            let group = res.data.values;
            setMember(group)
        })
    }, []);

    const PersonPaper = (props)=>{
        return(
            <Paper key={props.id} elevation={0} className={classes.paperContainer}>
                <Grid container spacing={3}>
                    <Grid item xs={2}>
                        <AccountCircleIcon style={{ fontSize: 55, marginTop: "-8" }} />
                    </Grid>
                    <Grid item xs={8}>
                        <Typography className={classes.paperText}>{props.name}</Typography>
                    </Grid>
                </Grid>
            </Paper>
        )
    }


    return (
        <div className={classes.root}>
            <Box display="flex" flexDirection="row" p={1} m={1} bgcolor="background.paper" >
                <Box p={1} onClick={() => history.push('/scanmember')}>
                    <Button style={{flex:1}} variant="contained" color="primary" >
                    +
                    </Button>
                </Box>
            </Box>
            <Container className={classes.menuContainer}>
                {member.map(person => <PersonPaper id={person.chip_id} name={person.fullname} />)}
            </Container>
        </div>
    )
}
